export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      
      this.diagram = this.Queries.SQL1[0] ? JSON.parse(JSON.stringify(this.Queries.SQL1[0])) : {}
      this.stages  = JSON.parse(JSON.stringify(this.Queries.SQL2))

      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.config     = json.config
      this.project    = json.project
      this.database   = json.database
      this.dataType   = json.dataType

      this.CRT = {id: -1, count: -1}


      this.sundries   = json.sundries
    },

  }
}